import React from 'react';

import { Input, Select, Tooltip, Button } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { Form } from '@ant-design/compatible';

import { graphql, compose } from 'react-apollo';
var moment = require('moment');
import _ from 'lodash';
const FormItem = Form.Item;
const Option = Select.Option;

import getTipoExpedientes from '../../../graphql/querys/contravenciones/getTipoExpedientes.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

@compose(
  graphql(getTipoExpedientes, { name: 'getTipoExpedientes' }),
  graphql(getUsuario)
)
class FormCrearExpediente extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Received values of form: ", values);
        this.props.onSubmit({
          idOrganismo: this.props.data.getUsuario.organismo._id,
          ...values,
        });
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  onChangeCheckbox = e => {
    // console.log(`checked = ${e.target.checked}`);
    this.setState({
      ...this.state,
      existeVenta: e.target.checked,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let listaTipoExpedientes = this.props.getTipoExpedientes.getTipoExpedientes;

    if (!listaTipoExpedientes) {
      listaTipoExpedientes = [];
    }

    return (
      <div>
        <h1 className="tituloForm">Creacion del Expediente</h1>

        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40 }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Tipo del Expediente
                <Tooltip title="Lo que el declarante quiere declarar ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('tipo', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el tipo de expediente!',
                  whitespace: true,
                },
              ],
            })(
              <Select
                showSearch
                style={{ width: 300, color: '#000000' }}
                placeholder="Tipo de Expediente"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {_.map(listaTipoExpedientes, tipo => {
                  return (
                    <Option key={tipo._id} value={tipo._id}>
                      {tipo.nombre}
                    </Option>
                  );
                })}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Codigo Organismo
                <Tooltip title="El codigo del organismo ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('codigoOrganismo', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el codigo del organismo!',
                  whitespace: true,
                },
              ],
              initialValue: this.props.data.getUsuario.organismo
                .codigoOrganismo,
            })(
              <Input style={{ width: 300, color: '#000000' }} disabled={true} />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Año
                <Tooltip title="Año que fue generado el expediente ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('anio', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el año!',
                },
              ],
              initialValue: moment().format('YYYY'),
            })(
              <Input style={{ width: 300, color: '#000000' }} disabled={true} />
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Generar Expediente
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormCrearExpediente);
